import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import VisuallyHidden from '../../../a11y/VisuallyHidden';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import SquareHeartFilledSmall from '../../../Icons/16x16/SquareHeartFilled';
import SquareHeartOutlinedSmall from '../../../Icons/16x16/SquareHeartOutlined';
import { IconSize } from '../../../Icons/IconWrap';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import shortenNumber from '../../../utils/shortenNumber';
import { CommentContext } from '../CommentContext';
import s from './LikeButton.scss';
var LikeButton = function (_a) {
    var _b;
    var className = _a.className, disabled = _a.disabled, onLike = _a.onLike, onUnlike = _a.onUnlike;
    var t = useTranslation().t;
    var comment = useContext(CommentContext).comment;
    var onClickLike = function () {
        // don't allow liking your own comment
        if (comment.isAuthor) {
            return;
        }
        if (comment.isLiked) {
            onUnlike(comment);
        }
        else {
            onLike(comment);
        }
    };
    var isAuthor = comment.isAuthor, isLiked = comment.isLiked, likes = comment.likes;
    var canLike = !isAuthor;
    var HeartIconSmall = isLiked
        ? SquareHeartFilledSmall
        : SquareHeartOutlinedSmall;
    var heartClasses = classnames(s['like'], isAuthor && s['not-clickable']);
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['likebutton'], className), onClick: onClickLike, disabled: disabled, "data-hook": BiDataHook.COMMENT_LIKE_BUTTON, biData: canLike
            ? {
                evid: BiEventType.CLICK_COMMENT_LIKE,
                commenterid: (_b = comment.user) === null || _b === void 0 ? void 0 : _b.useridUuid,
                commentid: comment.commentId,
                typeid: comment.typeId,
                itemid: comment.itemId,
                is_liking: isLiked ? undefined : 1,
            }
            : undefined, "aria-label": t('comment.a11y.action.like') },
        React.createElement(HeartIconSmall, { className: heartClasses, size: IconSize.SMALLER, disableDefaultColors: true }),
        likes > 0 && (React.createElement("span", { className: s['likes'] },
            shortenNumber(likes),
            React.createElement(VisuallyHidden, null, t('comment.action.likes', { count: likes }))))));
};
LikeButton.displayName = 'LikeButton';
export default LikeButton;
//# sourceMappingURL=LikeButton.js.map